import { createPublicClient, http } from "viem";
import { avalanche } from "viem/chains";

const publicClient = createPublicClient({
  chain: avalanche,
  transport: http(),
});
const ERC20_ABI: any = [
  {
    constant: true,
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }],
    type: "function",
  },
];

async function checkAllowance(
  Token_adress: any,
  Wl_address: any,
  Contract_adress: any
) {
  try {
    const Allowance = await publicClient.readContract({
      address: Token_adress,
      abi: ERC20_ABI,
      functionName: "allowance",
      args: [Wl_address, Contract_adress],
    });
    return Allowance;
  } catch (error) {
    console.error("Checking allowance error:", error);
  }
}

export default checkAllowance;
